import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-header-search',
    templateUrl: './header-search.component.html',
    styleUrl: './header-search.component.scss',
    standalone: false
})
export class HeaderSearchComponent {
    private searchSubject = new Subject<string>();
    @Input() addText?: string = undefined;
    @Input() headerText?: string = undefined;
    @Input() onAddClick: () => void = () => { };

    onInput(e: Event) {
        const val = (e.target as any).value;
        this.searchSubject.next(val);
    }
}
